import { render, staticRenderFns } from "./LessonProgress.vue?vue&type=template&id=784e8c4a&scoped=true&"
import script from "./LessonProgress.vue?vue&type=script&lang=ts&"
export * from "./LessonProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784e8c4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/iwata/Documents/Project/SMILE-AYA/dev/smileaya-admin-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
